/**
 * Tiny wrapper around the Vibration API.
 *
 * Mobile-only — desktop Chrome/Safari just returns false silently.
 * Pattern presets keep call-sites short and consistent across the app.
 */

type HapticPattern = 'tap' | 'success' | 'warning' | 'error';

const PATTERNS: Record<HapticPattern, number | number[]> = {
  tap: 10,
  success: [10, 40, 20],
  warning: [20, 60, 20],
  error: [40, 30, 40, 30, 40],
};

export function haptic(pattern: HapticPattern = 'tap'): boolean {
  if (typeof navigator === 'undefined' || !('vibrate' in navigator)) return false;
  try {
    return (navigator as Navigator).vibrate(PATTERNS[pattern]);
  } catch {
    return false;
  }
}
